import type { DiscoveredRouteModule } from '@/router/generator/types';

const RolesView = () => import('@/views/RolesView.vue');
export const NAME_ROLES = 'Roles';
export const PATH_ADMIN_ROLES = 'roles';

export const route: DiscoveredRouteModule = {
  id: 'admin.roles',
  scope: 'admin',
  moduleKey: 'roles',
  name: NAME_ROLES,
  path: PATH_ADMIN_ROLES,
  component: RolesView,
  meta: { requiresAuth: true, requiresAdmin: true, allowedRoles: ['admin', 'owner'], dataLoaders: ['project_document', 'features'] },
};
